module.exports = __webpack_public_path__ + "html/img/treasure_box.db923eda.png";